<div class="tw-grid tw-grid-cols-2 tw-mb-3 tw-pb-15"
     [class]="isShopRevampExperimentOn ? 'tw-gap-y-8 tw-gap-x-6 tw-px-6 tw-font-lexend' : 'tw-gap-2 tw-px-4'">
  @for(item of products; track item.objectId; let i = $index) {
  <div class="tw-animate-anim_fadeIn" style="box-shadow: unset;" *ngIf='item.price !== 0 && (item.productUnboxedImage?.length || item.rebrandedImageWithBackground?.length)' (click)="viewProduct(item)">
    <div class="tw-flex tw-flex-col tw-justify-between tw-h-full"  [id]="item?.objectId" [class]="{'tw-items-center': !isShopRevampExperimentOn}">
      <div class="tw-relative">
        <img [class]="isShopRevampExperimentOn ? 'tw-w-full tw-h-full tw-rounded-t-3' : 'tw-mb-[14px] tw-w-40 tw-h-50 tw-rounded-[20px]'"      
              class="tw-object-contain"
              alt="product"
              #img
              [src]='item?.rebrandedImageWithBackground && item?.rebrandedImageWithBackground.length ? item.rebrandedImageWithBackground[item.rebrandedImageWithBackground.length - 1] : false || item.productUnboxedImage[item.productUnboxedImage.length - 1] || item.images[item.images.length - 1]' />
        <div *ngIf="showRemoveProductIcon" (click)="onRemoveProduct(item, $event)">
          <cs-icon class="tw-absolute tw-top-2 tw-right-2 tw-h-6 tw-w-6 tw-text-gray-900" [iconName]="'close'"></cs-icon>
        </div>
      </div>
      @if (isShopRevampExperimentOn) {
        <div class="tw-text-300 tw-leading-[18px]" style="margin-bottom: unset;">
          <div class="tw-text-300 tw-leading-[18px] tw-mt-2" id="productTitleRebranded">{{item.title}}</div>
        </div>
        <div class="tw-leading-[18px] tw-font-bold tw-mt-1 tw-mb-2">
          <del class="tw-pr-1 tw-text-200 tw-text-gray-500">₹{{item?.mrp}}</del><span class="tw-text-300 tw-text-orange-500">₹{{item?.price}}</span>
        </div>
        <div *ngIf="getProductQuantityInCart(item) > 0" class="tw-h-8 tw-border tw-border-teal-600 tw-rounded-2 tw-flex tw-w-fit tw-items-center tw-text-300 tw-bg-white tw-text-teal-600 tw-font-lexend tw-font-semibold swiper-no-swiping">
          <div class="tw-px-[11.5px] tw-flex">
            <cs-icon [iconName]="'minus'" class="tw-w-[9px] tw-h-5 tw-text-teal-600" (click)='addOrRemoveFromCart(item, "REMOVE", $event, img)'></cs-icon>
          </div>
          <span class="tw-px-1">{{ getProductQuantityInCart(item) }}</span>
          <div class="tw-px-[11.5px] tw-flex">
            <cs-icon [iconName]="'plus'" class="tw-w-[9px] tw-h-5 tw-text-teal-600" (click)='addOrRemoveFromCart(item, "ADD", $event, img)'></cs-icon>
          </div>
        </div>
        <button csButton
                size="small"
                *ngIf="getProductQuantityInCart(item) === 0"
                (click)='addOrRemoveFromCart(item, "ADD", $event, img)'
                class="tw-min-w-fit tw-w-fit tw-px-[26px]"
                style="margin: 0 !important;">
          <span class="tw-text-300" i18n="@@add">Add</span>
        </button>
      } @else {
        <div class="tw-m-5 tw-text-center tw-text-[14px] tw-mt-0" style="margin-bottom: unset;">
          <div class="tw-text-[12px] font12" id="productTitle">{{item.title}}</div>
        </div>
        <div class="tw-text-[1.2rem] tw-leading-[1.8rem] tw-tracking-[1px] tw-font-bold tw-text-center tw-mx-5 tw-mt-1 tw-mb-2">
          <del class="tw-pr-1">₹{{item.mrp}}</del><span class="tw-text-orange-500">₹{{item.price}}</span>
        </div>
        <div
          class="tw-h-[36px] tw-max-w-36 tw-min-w-36 tw-border tw-border-teal-600 tw-rounded-3 tw-flex tw-justify-evenly tw-items-center tw-m-[10px] tw-text-300 tw-font-bold tw-font-body tw-bg-white tw-text-teal-600"
          *ngIf="getProductQuantityInCart(item) > 0">
          <em class="cs-icon-minus" (click)='addOrRemoveFromCart(item, "REMOVE", $event, img)'></em>
          <span>
            {{ getProductQuantityInCart(item) }}
          </span>
          <em class="cs-icon-plus" (click)='addOrRemoveFromCart(item, "ADD", $event, img)'></em>
        </div>
        <div class="tw-mx-[5px] tw-my-[10px] tw-rounded-[14px] " *ngIf="getProductQuantityInCart(item) === 0" (click)='addOrRemoveFromCart(item, "ADD", $event, img)'>
          <div></div>
          <div
            class="tw-flex tw-items-center tw-py-[6px] tw-px-4 tw-gap-2 tw-text-white tw-font-bold tw-h-9 tw-bg-teal-600 tw-rounded-3"
          >
            <span i18n="@@addToCart">Add to Cart</span>
            <em class="cs-icon-arrow tw-translate-y-[1px]"></em>
          </div>
        </div>
      }
    </div>
  </div>
  }
</div>
